import ArrayProxy from "@ember/array/proxy"
import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import _ from "lodash"
import { all } from "rsvp"
const ArrayPromiseProxy = ArrayProxy.extend(PromiseProxyMixin)

/**
 * A macro that creates a computed property that returns a single promise object that resolves
 * to an array of objects of the type specified in the relationshipType parameter when fulfilled
 *
 * @param  {String} keyName
 * @param  {String} relationshipType
 * @return {ObjectPromiseProxy} returns a promise object that resolves to an array of objects when all values in the array are fulfilled.
 * The array can be accessed via the content object.
 */
export default function findMany(keyName: string, relationshipType: string) {
  /**
   * Example:

    ``` javascript
      class exampleComponent extends Component {
        visibleCourseIds = [ 1, 2, 3, 4 ]
        @findMany("visibleCourseIds", "course") visibleCourses
      }
    ```
   */
  return computed(`${keyName}.[]`, `${keyName}.length`, function () {
    let ids = get(this, keyName)
    if (get(this, "store") === undefined)
      throw Error("You need to inject the store to use the findMany function")
    return ArrayPromiseProxy.create({
      promise: all(
        _.map(ids, (id) => {
          return get(this, "store").find(relationshipType, id)
        })
      ),
    })
  })
}
